//This is a wrapper for the Generic Pairing Card
import { connect } from 'react-redux';
import PairingCard from '../../generic/PairingCard';
import { toggleRdpModal } from '../action_creators';

const CPairingCard = ({ data, toggleRdpModal }) => {
  return (
    <div className="cpairing-card">
      <PairingCard
        testid="cpairing-card"
        pairingId={data.id}
        pairingData={data}
        cardType={3}
        onClick={() => toggleRdpModal(data)}
        isRecipesPage={true}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleRdpModal: (pairing) => dispatch(toggleRdpModal(pairing)),
  };
};

export default connect(null, mapDispatchToProps)(CPairingCard);
